export default __webpack_public_path__ + "fce0dd826e17f3fa0ff116dbe5655a0d.woff2";